export const IMS_ORG_EXTENSIONS = [];
export const NON_IMS_EXTENSIONS = [];
export const ALL_EXTENSIONS = [...IMS_ORG_EXTENSIONS, ...NON_IMS_EXTENSIONS];

export const routes = ALL_EXTENSIONS.map((ext) => ({
  path: ext.MAIN_ROUTE,
  component: ext.Panel
}));
